const CustomHowToEnter = ({competition}) => {
    return (
      <div className="card p-3">
        <div className="section-title">
          <h5 className="madeGentle border-bottom pb-2">How To Enter</h5>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <p
              className="text-muted Archivo"
              style={{
                display: "flex",
                flexDirection: "row",
                overflow: "auto",
              }}
            >
              <span>1.</span>
              <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: competition?.creativeDirection,
                    }}
                    style={{ overflow: "auto" }}
                  ></div>
                </>
            </p>
          </div>
          
          
        </div>
      </div>
    );
}

export default CustomHowToEnter;